// @flow
import * as React from 'react';

import {JsonResponse} from '../helpers/commands/resource';
import type {Command} from '../helpers/commands/resource';

// / Function that handles running resource execution
export function resource(
  stripeCommand: Command,
  args: Array<string>,
  flags: {[string]: string},
  apiKey: string,
  setAllowInput: (boolean) => void,
): React.Node {
  if (
    stripeCommand.args &&
    stripeCommand.args.length > 0 &&
    args.length !== stripeCommand.args.length
  ) {
    setAllowInput(true);
    // todo(tomer) - be smarter and only mention the additional args needed
    return `Wrong number of arguments passed. Expected arguments: ${stripeCommand?.args?.join() ??
      ''}`;
  }

  const requestPath = mergeArgs(args, stripeCommand.path);
  const method = stripeCommand.method;

  if (!requestPath || !method) {
    setAllowInput(true);
    return 'Error, something went wrong';
  }

  return (
    <JsonResponse
      path={requestPath}
      method={method}
      params={flags}
      api_key={apiKey}
      setAllowInput={setAllowInput}
    />
  );
}

// Some API paths rely on ids to be part of the path. ids are passed
// as args to the command itself so we need to merge them into the
// path. The path expects ids as {id_name}, but args are not named.
//
// This function takes the list of args provided and merges them into
// the request path on the expectation that the arts are passed in
// the same order as the expected ids
//
// Note: this is exported only for testing purposes
export function mergeArgs(
  args: Array<string>,
  requestPath?: string,
): string | null {
  // There might be a case where requestPath from the gen tree is
  // null, so return that back for generic error handling
  if (!requestPath) {
    return null;
  }

  // Find all matches in the request path of the shape: {id}
  const matches = requestPath.match(/({[a-z]*})/g) || [];

  // If there are no args or matches, return the path as-is
  if (args.length === 0 && matches.length === 0) {
    return requestPath;
  }

  // The user may have passed in too many args or not enough
  if (args.length !== matches.length) {
    // todo(tomer) - be smarter and only mention the additional args needed
    return null;
  }

  // Iterate through each match and replace it with an id
  let newPath = requestPath;
  matches.forEach((match, i) => {
    newPath = newPath.replace(match, args[i]);
  });

  return newPath;
}
